export const SET_DEVICE_DATA = 'set-device-data';
const setDeviceData = ({ deviceData }) => ({ type: SET_DEVICE_DATA, payload: { deviceData } });
export default setDeviceData;
